import { useState } from 'react';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { Button } from '@material-ui/core';
import NgpTwoButtonDialog from '../dialog-two-button/NgpTwoButtonDialog';

const defaultConfirmTitle = i18n._(t`Please confirm`);
const defaultConfirmButtonText = i18n._(t`Ok`);
const defaultCancelButtonText = i18n._(t`Cancel`);

export default function ConfirmButton({
    handleConfirm,
    disabled = false,
    plural = false,
    confirmText,
    confirmTextPlural,
    isWarning,
    title = defaultConfirmTitle,
    confirmButtonText = defaultConfirmButtonText,
    cancelButtonText = defaultCancelButtonText,
}) {
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const handleConfirmation = () => {
        setShowConfirmationDialog(true);
    };

    const theConfirmText = plural ? confirmTextPlural : confirmText;

    return (
        <>
            <Button onClick={handleConfirmation} disabled={disabled}>
                {confirmButtonText}
            </Button>
            <NgpTwoButtonDialog
                title={title}
                confirmButtonText={confirmButtonText}
                cancelButtonText={cancelButtonText}
                open={showConfirmationDialog}
                setOpen={setShowConfirmationDialog}
                onConfirm={handleConfirm}
                isWarning={isWarning}
                closeInTitleBar={false}
            >
                <div>{theConfirmText}</div>
            </NgpTwoButtonDialog>
        </>
    );
}
